import React, { Component } from 'react';
import { translate } from 'react-i18next';

import Layout from 'components/Layout/Layout';

class Main extends Component {

  render() {
    return (
      <div className='app-container'>
        <Layout history={this.props.history} option='main' />
      </div>
    );
  }
}

export default translate()(Main);
